export enum VerificationType {
    AUTOMATIC,
    MANUAL
}
